import { usePropertyState } from '../../../../../queries/usePropertyCoreFields';
import {
    DropDownBoxComponentSpacing,
    Panel,
    PanelBorderRadius,
    PanelBorderStyle,
    PanelTheme,
    StateDropDown,
} from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useEffect, useState } from 'react';
import { ShowIf } from '../../../../components/ShowIf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

interface PropertyAddressStateProps {
    propertyGuid: string;
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
    validator?: React.ReactNode;
}

export const PropertyAddressState: React.FC<PropertyAddressStateProps> = ({
    propertyGuid,
    required = false,
    readOnly = false,
    isReview = false,
    validator,
}) => {
    const label = 'State';
    const [propertyAddressState, set_propertyAddressState] = usePropertyState(propertyGuid);
    const [showStateWarning, set_showStateWarning] = useState(false);
    const stateWarningMessage =
        'Lending may not be available in this state, you may wish to confirm availability before proceeding.';
    const warningStates = ['HI', 'AK'];

    useEffect(() => {
        if (!propertyAddressState) {
            set_showStateWarning(false); // Consider empty valid, or adjust as needed.
        }
        set_showStateWarning(warningStates.includes(propertyAddressState ?? ''));
    }, [propertyAddressState]);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={propertyAddressState}
                />
            ) : (
                <>
                    <StateDropDown
                        id='propertyAddressState'
                        value={propertyAddressState}
                        onChange={(value) => set_propertyAddressState(value)}
                        label={label}
                        required={required}
                        width='220px'
                        readOnly={readOnly}
                        validator={validator}
                        componentSpacing={DropDownBoxComponentSpacing.SmallSpacing}
                    />
                    <ShowIf showIf={showStateWarning}>
                        <Panel
                            theme={PanelTheme.Yellow}
                            borderStyle={PanelBorderStyle.Solid}
                            borderRadius={PanelBorderRadius.Small}
                        >
                            <div style={{ display: 'flex' }}>
                                <FontAwesomeIcon
                                    icon={faExclamationTriangle}
                                    style={{ float: 'left', color: '#cc8c00' }}
                                />
                                <div style={{ marginLeft: '10px', float: 'right', opacity: '60%' }}>{stateWarningMessage}</div>
                            </div>
                        </Panel>
                    </ShowIf>
                </>
            )}
        </>
    );
};
